export default __webpack_public_path__ + "static/media/PrepPlanningOrangeIcon.9550cf45.png";